import { Contact } from '../types/contact';
import { http } from '../util/https.util';
import { PaginatedResponse } from './common/paginatedResponse';

const LIST = '/api/contact/list';

export namespace ContactRequest {
  export const list = async (payload: { page: number }): Promise<PaginatedResponse<Contact>> => {
    return (await http.post(LIST, payload)).data;
  };
}
